function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20,1 L20,15 C20,15.553 19.552,16 19,16 L14,16 L14,5 C14,3.897 13.103,3 12,3 L7,3 L7,1 C7,0.447 7.448,0 8,0 L19,0 C19.552,0 20,0.447 20,1 Z M6,18.7304326 C6,18.9703977 5.70945933,19.0898422 5.5405153,18.9208982 L1.07910184,14.4594847 C0.910157817,14.2905407 1.02960232,14 1.26956739,14 L4.96911864,14 C5.53836315,14 6,14.4616368 6,15.0308814 L6,18.7304326 Z M12,4 L1,4 C0.448,4 0,4.447 0,5 L0,14.586 C0,14.851 0.105,15.105 0.293,15.293 L4.707,19.707 C4.895,19.895 5.149,20 5.414,20 L12,20 C12.552,20 13,19.553 13,19 L13,5 C13,4.447 12.552,4 12,4 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/copy.a9fd9374.svg";
export { SvgComponent as ReactComponent };